module.exports = __webpack_public_path__ + "OM.png?9bcb7202de9781ca016fe9edb042beaa";